export default __webpack_public_path__ + "static/media/illustration-recruit-3-w@3x.af1dfdf1.webp";